import { CustomColumn } from '../../types/customColumn';
import { QzTrayCertificate } from '../../types/qztray/QzTrayCertificateTypes';

const formatDateTime = (value?: string | null) => {
  if (!value) return '—';

  return new Date(value).toLocaleString('es-SV', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

const getCertificateTypeLabel = (type: QzTrayCertificate['type']) => {
  if (type === 'CERTIFICATE') return 'Certificado público';
  if (type === 'PRIVATE_KEY') return 'Llave privada';
  return type;
};

export const qzTrayCertificateColumns: CustomColumn<QzTrayCertificate>[] = [
  {
    Header: 'Tipo de Certificado',
    accessor: 'type',
    customCell: ({ row }) => (
      <div className="text-sm leading-6">
        <div className="font-medium text-black dark:text-white">
          {getCertificateTypeLabel(row.original.type)}
        </div>

        <div className="mt-1 text-xs text-gray-600 dark:text-gray-400">
          {row.original.type}
        </div>
      </div>
    ),
  },
  {
    Header: 'Nombre del Archivo',
    accessor: 'fileName',
    customCell: ({ row }) => (
      <span className="text-sm text-gray-700 dark:text-gray-300">
        {row.original.fileName || '—'}
      </span>
    ),
  },
  {
    Header: 'Ruta del Archivo',
    accessor: 'filePath',
    customCell: ({ row }) => (
      <div
        className="
          text-sm
          text-gray-500
          dark:text-gray-400
          whitespace-normal
          break-all
        "
      >
        {row.original.filePath || 'No disponible'}
      </div>
    ),
  },
  {
    Header: 'Expira',
    accessor: 'expirationDate',
    customCell: ({ row }) => (
      <span className="text-sm text-gray-500 dark:text-gray-400">
        {formatDateTime(row.original.expirationDate)}
      </span>
    ),
  },
  {
    Header: 'Última Actualización',
    accessor: 'updatedAt',
    customCell: ({ row }) => (
      <span className="text-sm text-gray-500 dark:text-gray-400">
        {formatDateTime(row.original.updatedAt)}
      </span>
    ),
  },
  {
    Header: 'Estado',
    accessor: 'status',
    customCell: ({ row }) => {
      const available = Boolean(row.original.filePath);

      return (
        <span
          className={`inline-flex rounded-full px-3 py-1 text-sm font-medium ${
            available
              ? 'bg-green-500 text-white'
              : 'bg-[#DC3545] text-white'
          }`}
        >
          {available ? 'Disponible' : 'No disponible'}
        </span>
      );
    },
  },
];